export enum QuestionStatus {
    Answered = 'Answered',
    Pending = 'Pending',
}